import React, { useState } from 'react'
import { CrossIcon } from 'assets/icons/index'
import Popup from 'components/ui-kit/Popup/index'
import { PER_PAGE_LIMIT } from 'games/CrashGame/crashgame.constants'
import { formatDateTime } from 'helpers/common.helpers'

const BetHistoryModal = ({
  isOpenHistoryModal,
  setIsOpenHistoryModal,
  currentOffset,
  setCurrentOffset,
  roundHistory
}) => {
  const itemsPerPage = PER_PAGE_LIMIT
  const [currentPage, setCurrentPage] = useState(0)

  const data = [
    { time: '2024-08-22T14:30:00Z', multiplier: 1.5 },
    { time: '2024-08-22T14:35:00Z', multiplier: 2.1 },
    { time: '2024-08-22T14:40:00Z', multiplier: 0.9 },
    { time: '2024-08-22T14:45:00Z', multiplier: 3.2 },
    { time: '2024-08-22T14:50:00Z', multiplier: 1.8 },
    { time: '2024-08-22T14:55:00Z', multiplier: 2.5 },
    { time: '2024-08-22T15:00:00Z', multiplier: 1.2 },
    { time: '2024-08-22T15:05:00Z', multiplier: 1.7 },
    { time: '2024-08-22T15:10:00Z', multiplier: 0.6 },
    { time: '2024-08-22T15:15:00Z', multiplier: 2.9 },
    { time: '2024-08-22T15:20:00Z', multiplier: 3.0 },
    { time: '2024-08-22T15:25:00Z', multiplier: 1.4 },
    { time: '2024-08-22T15:30:00Z', multiplier: 2.2 },
    { time: '2024-08-22T15:35:00Z', multiplier: 1.9 },
    { time: '2024-08-22T15:40:00Z', multiplier: 3.4 },
    { time: '2024-08-22T15:45:00Z', multiplier: 0.8 },
    { time: '2024-08-22T15:50:00Z', multiplier: 2.7 },
    { time: '2024-08-22T15:55:00Z', multiplier: 1.6 },
    { time: '2024-08-22T16:00:00Z', multiplier: 2.3 },
    { time: '2024-08-22T16:05:00Z', multiplier: 3.1 }
  ]

  const handleNext = () => {
    if (currentPage < Math.ceil(data.length / itemsPerPage) - 1) {
      setCurrentPage(currentPage + 1)
    }
  }

  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1)
    }
  }

  const startIndex = currentPage * itemsPerPage
  const paginatedData = roundHistory ? roundHistory?.slice(startIndex, startIndex + itemsPerPage) : []

  return (
    <Popup className='bet-history-modal' isOpenModal={isOpenHistoryModal}>
      <div className='text-center text-white'>
        <div className='bet-history-title d-flex justify-content-between mb-4'>
          <h5 className='mb-0 modalHeading'>Crash History</h5>
          <div className='cursor-pointer' onClick={() => { setIsOpenHistoryModal(false) }}>
            <CrossIcon />
          </div>
        </div>

        <div className='historySection'>
          <div className='d-flex justify-content-between historyHeading'>
            <p>
              Time
            </p>
            <p>
              Multiplier
            </p>
          </div>
          <div className='historyDetail'>
            <ul className='p-0 m-0 list-unstyled'>
              {paginatedData.map((item, index) => (
                <li className='d-flex justify-content-between' key={index}>
                  <span>{formatDateTime(item.createdAt)}</span>
                  <span>{(item.crashRate).toFixed(2)}x</span>
                </li>
              ))}
            </ul>
            <div className='pagination-buttons'>
              <button onClick={handlePrev} disabled={currentPage === 0}>
                Prev
              </button>
              <button
                onClick={handleNext}
                disabled={currentPage === Math.ceil(data.length / itemsPerPage) - 1}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

    </Popup>
  )
}

export default BetHistoryModal
